import { AfterViewInit, Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActivityTabs, AvailabilityCriteria, buttonTypes, ComponentTypes, PartyState } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { ActivityRatePlanRequest, ActivitySlotRequestDTO, AvailabilityType, BookingActivity, BookingBehavior, ClassType, LockSessionRequestDTO, SessionBookingDTO } from 'src/app/shared/Models/SessionBookingDTO';
import { DayOfWeek, operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { environment } from 'src/environments/environment';
import { urlConfig } from '../../../shared/constants/url-config'
@Component({
    selector: 'app-activity-selector',
    templateUrl: './activity-selector.component.html',
    styleUrls: ['./activity-selector.component.scss'],
    standalone: false
})
export class ActivitySelectorComponent extends Utilities implements OnInit, AfterViewInit, OnDestroy {
  previousButton: ButtonValue;
  nextButton: ButtonValue;
  cancelButton: ButtonValue;
  CheckAvailabilityBtn: ButtonValue;
  reservationConfig: FieldConfig[];
  locationConfig: FieldConfig[];
  customizeSizeConfig: FieldConfig[];
  from_dateConfig: FieldConfig[];
  to_dateConfig: FieldConfig[];
  age_config: FieldConfig[];
  search_config: FieldConfig[];
  buttonType = buttonTypes;
  coverTypeConfig: FieldConfig[];
  bookingTypeConfig: FieldConfig[];
  bookingType_config: FieldConfig[];
  coverTypes = [];
  bookingTypes = [];
  classDetail: any;
  @ViewChild('reservationConfigForm', { static: true }) reservationConfigForm: DynamicFormComponent;
  @ViewChild('dateConfigForm', { static: true }) dateConfigForm: DynamicFormComponent;
  @ViewChild('coverTypeForm', { static: true }) coverTypeForm: DynamicFormComponent;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  Subscriptions: Subscription = new Subscription();
  availableActivities: any;
  tempAvailableActivities: any;
  SelectedIndex: number;
  SelectedActivityData: any;
  InstructorList: any[];
  LocationList: any[];
  minSizeAllowed: number = 1;
  bookingSizeArray: any = [];
  SessionSlotsAvailableDates: any = null;
  showSessionorSlots: boolean = false;
  isSessionClass: any;
  selectedIndex: number = 0;
  public sessionsUnavailable: any[];
  isMultiSlotSelection: any;
  availableSessions: any[];
  classLessonList: any[];
  selectedClassSchedule: any = [];
  dayOfWeek = DayOfWeek;
  EditData: any;
  lockResponse: any;
  ratePlan: any;
  checkedItem = false;
  operatingCurrency: any;
  SelectedTimeSlots: any = [];
  Operation = operationType;
  validCoverTypes: boolean = true;
  validBookingTypes: boolean = true;
  validGroupSize: boolean = true;
  formRepeatCount = 0;
  widgetData: any;
  currentTab = 0;
  imageUrl: any;
  environment = environment;
  constructor(private ts: TranslateService, public activityService: GuestService, public dialog: MatDialog, private gs: GuestService) {
    super(dialog);
    this.Subscriptions.add(this.activityService.editPartyData$.subscribe(data => {
      this.EditData = data;
      if (this.EditData &&
         (this.EditData.State === PartyState.Seated ||
         this.EditData.State === PartyState.Cancelled ||
         this.EditData.State === PartyState.Left)) {
         this.activityService.TabChange$.next(ActivityTabs.ConfirmationSummary);
      }
      if (this.EditData && this.EditData.Contact?.TrackMembershipNumber) {
        this.CheckMemberShip(this.EditData.Contact.TrackMembershipNumber, this.EditData);
      }
    }));
    this.Subscriptions.add(this.activityService.restaurantWidgetSettings$.subscribe(value => {
      this.widgetData = value;
      this.isMultiSlotSelection = value.EnableMultiSlotSelection;
      this.operatingCurrency = value.OperationCurrency;
    }));

    this.Subscriptions.add(this.activityService.TabChange$.subscribe(data => {
      this.currentTab = data;
      if (data === ActivityTabs.ActivitySelection && this.EditData && this.EditData.ReservedFor &&
        this.activityService.bookingSection$.value === BookingActivity.ClassBooking) {
        if (this.EditData && this.EditData.Contact?.TrackMembershipNumber) {
          this.CheckMemberShip(this.EditData.Contact.TrackMembershipNumber, this.EditData);
          setTimeout(() => {
            this.checkSessionorSlotAvailability();
          }, 300);
        } else {

          this.checkSessionorSlotAvailability();
        }
      }
    }));
    this.Subscriptions.add(this.activityService.SelectedActivity$.subscribe(data => {
      if (this.activityService.operation === operationType.create) {
        this.resetValue();
      }
      setTimeout(() => {
        this.classDetail = data;
        if (this.classDetail && this.activityService.bookingSection$.value === BookingActivity.ClassBooking) {
          this.activityService.selectedSpecialMeal = this.classDetail;
          this.SelectedActivityData = this.classDetail;
          this.createReservationConfig();
          this.createActionButtons();
          this.selectedClassActivity(this.SelectedActivityData);
        }
      }, 100);

    }));
    this.Subscriptions.add(this.activityService.bookingSection$.subscribe(data => {
      if (this.components && this.activityService.operation === operationType.create && data) {
        this.resetValue();
      }
    }));
    this.Subscriptions.add(this.activityService.BookNew$.subscribe(data => {
      if (data) {
        if (this.components) {
          this.resetValue();
        }
        this.activityService.BookNew$.next(false);
      }
    }));
  }




  ngOnInit(): void {

    if (this.activityService.SelectedActivity$.value) {
      this.SelectedActivityData = this.activityService.SelectedActivity$.value;
    }
    this.createReservationConfig();
    this.createActionButtons();
  }

  createReservationConfig() {
    this.reservationConfig = [
      {
        type: 'select',
        name: 'Instructor',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        value: this.EditData ? this.EditData.StaffIds && this.EditData.StaffIds.length > 0 && this.EditData.StaffIds.length !== this.InstructorList?.length ? this.EditData.StaffIds[0] : -1 : -1,
        label: this.ts.instant('SelectaInstructor'),
        class: "activity-instructor",
        validation: [Validators.required],
      }

    ];
    this.locationConfig = [
      {
        type: 'select',
        name: 'Location',
        placeholder: '',
        options: [],
        appearance: true,
        isFormArray: false,
        value: this.EditData ? this.EditData.TableIds && this.EditData.TableIds.length > 0 && this.EditData.TableIds.length !== this.LocationList?.length ? this.EditData.TableIds[0] : -1 : -1,
        label: this.ts.instant('SelectaLocation'),
        class: "activity-instructor",
        validation: [Validators.required],
      }];

    this.updateDateConfig();
    this.customizeSizeConfig = [
      {
        type: 'autocomplete',
        name: 'BookingSize',
        placeholder: 'select',
        options: this.calculatePartySize(),
        appearance: true,
        partySize: true,
        isFormArray: false,
        class: "activity-instructor",
        showErrorText: true,
        charLength: this.SelectedActivityData?.MaxPartySize.toString().length,
        validation: [Validators.required, Validators.min(this.SelectedActivityData?.MinPartySize), Validators.max(this.SelectedActivityData?.MaxPartySize)],
        value: this.EditData ? this.EditData.Size ? this.EditData.Size : '' : ''
      },
    ]

    this.search_config = [
      {
        type: 'input',
        label: "",
        placeholder: 'SearchbyActivityName',
        name: 'SearchbyActivityName',
        inputType: 'text',
        class: 'guest-details__first-name',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        value: ''
      },
    ];
    this.bookingType_config = [
      {
        type: 'radio',
        name: 'bookingType',
        placeholder: 'selectCovers',
        options: [{ id: BookingBehavior.ClassOrSession, value: 'Lesson Booking' }, { id: BookingBehavior.OpenBooking, value: 'Open Booking' }],
        class: 'login__language-selection',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        multiCheck: true,
      }
    ];
  }
  resetValue() {
    if (this.components) {
      var [Instructor, Location, FromDate, ToDate, BookingSize, bookingtypes, covertype] = this.components;
      Instructor.form.reset("Instructor");
      Location.form.reset("Location");
      FromDate.form.reset("FromDate");
      ToDate.form.reset("ToDate");
      BookingSize.form.reset("BookingSize");
      if (bookingtypes) {
        bookingtypes.form.reset(this.getBookingTypeName());
      }
      if (covertype) {
        covertype.form.reset(this.getCoverTypeName());
      }
    }
  }
  getBookingTypeName(): FieldConfig[] {
    return this.bookingTypes.map(bookingType => {
      return bookingType.Name;
    })
  }
  getCoverTypeName(): FieldConfig[] {
    return this.coverTypes.map(coverType => {
      return coverType.Name;
    })
  }
  isFormValid() {
    var isValid = true;
    this.components.forEach(componet => {
      if (!componet.form.valid && componet.form.status !== "DISABLED") {
        isValid = false;
      }
    })
    return isValid;
  }

  getFormValue(formObj, fieldName) {
    return formObj && formObj.form.get(fieldName)?.value;
  }

  getCoverTypeValues(covers) {
    return this.coverTypes.map(coverType => {
      return { covers: covers[coverType.Name], Covers: covers[coverType.Name], CoverTypeId: coverType.Id, Name: coverType.Name }
    })
  }

  isCoverTypeMatchBookingSize() {

    var coverTypeTotal = 0;

    if (!this.coverTypeConfig || !this.coverTypeConfig.length) {
      return true;
    }
    else {
      if (!this.bookingTypeConfig || !this.bookingTypeConfig.length) {
        var [, , , , bookingSize, covers] = this.components;
        covers.controls.forEach((control, index) => {
          coverTypeTotal += +covers.form.controls[this.coverTypes[index].Name].value;
        });
      }
      else {
        var [, , , , bookingSize, , covers] = this.components;
        covers.controls.forEach((control, index) => {
          coverTypeTotal += +covers.form.controls[this.coverTypes[index].Name].value;
        });
      }
    }

    if (this.getFormValue(bookingSize, "BookingSize") === '') {
      return false;
    } else {
      return +this.getFormValue(bookingSize, "BookingSize") == coverTypeTotal;
    }
  }
  getBookingTypeValues(bookingTypes) {
    return this.bookingTypes.map(bookingType => {
      return { BookingTypes: bookingTypes[bookingType.Name], BookingTypeId: bookingType.Id, Name: bookingType.Name }
    })
  }
  isBookingTypeMatchBookingSize() {
    if (!this.bookingTypeConfig || !this.bookingTypeConfig.length) {
      return true;
    }
    var [, , , , bookingSize, bookingTypes,] = this.components;


    var bookingTypeTotal = 0;
    bookingTypes.controls.forEach((control, index) => {
      bookingTypeTotal += +bookingTypes.form.controls[this.bookingTypes[index].Name].value;
    });
    this.validBookingTypes = +this.getFormValue(bookingSize, "BookingSize") === bookingTypeTotal;
    return +this.getFormValue(bookingSize, "BookingSize") === bookingTypeTotal;
  }

  updateFormValidity() {
    return this.isFormValid() && this.isValidBookingSizeSelected() && this.isCoverTypeMatchBookingSize() && this.isBookingTypeMatchBookingSize() && this.checkedItem;
  }

  isValidBookingSizeSelected() {
    var [activity, , , , bookingSize] = this.components;
    let selectedSize = +this.getFormValue(bookingSize, "BookingSize")
    if (this.SelectedActivityData) {

      this.validGroupSize = true;
      this.validGroupSize = selectedSize >= this.SelectedActivityData.MinPartySize && selectedSize <= this.SelectedActivityData.MaxPartySize;

      const minsize = this.SelectedActivityData.MinPartySize;
      const maxsize = this.SelectedActivityData.MaxPartySize;
   
      return this.validGroupSize;
    }
    return false;
  }

  getFormComponent(...args) {
    return args.map(arg => this.components.find(form => form && form.form ? form.form?.value[arg] : form?.value[arg]))
  }

  checkSessionorSlotAvailability() {
    var [instructor, fromDate, toDate, bookingSize, location] = this.getFormComponent("Instructor", "FromDate", "ToDate", "BookingSize", "Location");
    var instructors = instructor.form.get("Instructor").value == -1 ? [] : [instructor.form.get("Instructor").value]

    var locations = location.form.get("Location").value == -1 ? [] : [location.form.get("Location").value]
    if (bookingSize) {
      this.getavailableSlots(instructors, locations, fromDate, toDate, bookingSize);
    }
  }



  CheckMemberShip(membershipId, editContactData) {
    this.Subscriptions.add(this.activityService.getContactFromEngagebyCardno(membershipId).subscribe(response => {
      if (response.Payload) {
        const memberShipdetail = response.Payload;
        let editPartyData = {
          Id: this.EditData && this.EditData.Id !== null ? this.EditData.Id : null,
          Contact: {},
        };
        const memberType = this.activityService.restaurantWidgetSettings$.value.AllocationMappings.find(allocation => allocation.AllocationTypeName.trim().toLocaleLowerCase() === memberShipdetail.MembershipType.trim().toLocaleLowerCase());
        const guestObject = {
          FirstName: memberShipdetail.FName,
          LastName: memberShipdetail.LName,
          EmailAddress:  memberShipdetail.Email,
          PhoneNumber: memberShipdetail.PhoneNumber,
          CountryId: this.activityService.getCountryId(memberShipdetail.PhoneCode),
          PIILastUsedDate: null,
          EmailAddress2: memberShipdetail.EmailList ? memberShipdetail.EmailList[1]?.EmailId : null,
          PhoneNumber2:memberShipdetail.PhoneList ? memberShipdetail.PhoneList[1]?.PhoneNumber: memberShipdetail.PhoneNumber,
          Birthday: memberShipdetail.Dob,
          ContactCustomFields: [],
          Notes: [],
          VisitStats: [],
          MarketingOptedIn: null,
          memberShipId: memberShipdetail.CardNo,
          MembershipType: memberShipdetail.MembershipType,
          MemberActive: memberShipdetail.MembershipStatus?.toLowerCase() === "active"
        }
        if (editContactData) {
          editContactData.memberShipId = memberShipdetail.CardNo,
            editContactData.MembershipType = memberType,
            editContactData.MemberActive = memberShipdetail.MembershipStatus?.toLowerCase() === "active"
        }
        this.activityService.selectedGuest = editContactData ? editContactData : guestObject;
        this.activityService.selectedGuest = guestObject;
        this.activityService.selectedGuest.TrackMembershipNumber = memberShipdetail.CardNo; // to bind it in the guest form
        this.activityService.membershipId = guestObject.MemberActive ? this.activityService.restaurantWidgetSettings$.value.AllocationMappings.find(x => x.AllocationTypeName.trim().toLowerCase() == response.Payload.MembershipType.trim().toLowerCase())?.AllocationTypeId : null;
      }
    }))
  }


  getavailableSlots(instructors, location, fromDate, toDate, bookingSize) {
    this.SessionSlotsAvailableDates = [];
    this.classLessonList = [];
    this.availableSessions = [];
    this.selectedIndex = 0;
    var requestedObject = {
      ActivityId: +this.SelectedActivityData.SpecialMealId,
      AvailabilityCriteria: this.getAvailabilityCriteria(location, instructors),
      StartDate: moment(fromDate?.form.get("FromDate").value).format("YYYY-MM-DD"),
      EndDate: moment(toDate?.form.get("ToDate").value).format("YYYY-MM-DD"),
      PreferredLocationId: location,
      PreferredStaffId: instructors,
      BookingSize: +bookingSize?.form.get("BookingSize").value,
      ClassType: this.SelectedActivityData.ClassType,
      reservationIdToIgnore: this.activityService.editPartyData$.value?.Id || null
    } as ActivitySlotRequestDTO;
    this.getSlotsForClass(requestedObject);
  }

  setBookingData() {
    var [instructor, fromDate, toDate, bookingSize, location] = this.getFormComponent("Instructor", "FromDate", "ToDate", "BookingSize", "Location");
    var covers = null;
    var bookingTypes = null;
    if (this.bookingTypeConfig && this.bookingTypeConfig.length) {
      bookingTypes = this.components['_results'][5].form.value;
      if (this.coverTypeConfig && this.coverTypeConfig.length) {
        covers = this.components['_results'][6].form.value;
      }
    }
    else if (this.coverTypeConfig && this.coverTypeConfig.length) {
      covers = this.components['_results'][5].form.value;
    }
    var instructors = instructor.form.get("Instructor").value == -1 ? this.InstructorList.filter(y => y.id !== -1).map(x => {
      return x.id;
    }) : [instructor.form.get("Instructor").value]

    var locations = location.form.get("Location").value == -1 ? this.LocationList.filter(y => y.id !== -1).map(x => {
      return x.id;
    }) : [location.form.get("Location").value]

    this.activityService.SessionBookingObj = new SessionBookingDTO(
      null,
      this.SelectedActivityData.SpecialMealId,
      this.SelectedActivityData.ClassType,
      this.getFormValue(fromDate, "FromDate"),
      this.getFormValue(toDate, "ToDate"),
      locations,
      this.SelectedActivityData.LocationName,
      instructors,
      this.getFormValue(bookingSize, "BookingSize"),
      '',
      this.getCoverTypeValues(covers),
      this.getBookingTypeValues(bookingTypes),
      this.getSlotsObj(),
      this.getSessionGroupId()
    );
    if (!this.isSessionClass) {
      this.activityService.SelectedClassSchedule$.next(this.selectedClassSchedule);
    }
    this.activityService.SessionBookingObj.AvailabilityCriteria = this.getAvailabilityCriteria(location, instructors);
    this.createSaveRequestObject();
  }

  getSlotsObj() {
    var resSlots = [];
    this.SelectedTimeSlots = [];

    this.SessionSlotsAvailableDates.forEach(availableDate => {

      var sessionsSelected = availableDate.AvailableSessions
        .filter(session => session.checked)
      sessionsSelected.forEach(element => {
        this.SelectedTimeSlots.push({
          SessionId: element.SessionId,
          Start: element.Start,
          End: element.End,
          Date: availableDate.AvailableDate
        })
      });
      sessionsSelected = sessionsSelected.map(session => session.SessionId);

      if (sessionsSelected.length) {

        resSlots.push({ Date: availableDate.AvailableDate, SessionIds: sessionsSelected })
      }
    });

    return resSlots;
  }

  getSessionGroupId() {
    if (!this.isSessionClass) {
      if (!this.selectedClassSchedule.length && this.SelectedActivityData) {
        return this.SelectedActivityData.SessionGroupId;
      } else if (this.selectedClassSchedule.length) {
        return this.selectedClassSchedule.find(item => item)[0].SessionGroupId;
      }
    }
    return null;
  }


  getAvailabilityCriteria(locations, instructors) {
    if (!locations.length && !instructors.length) {
      return AvailabilityCriteria.None
    } else if (locations.length && !instructors.length) {
      return AvailabilityCriteria.IncludeLocation
    } else if (!locations.length && instructors.length) {
      return AvailabilityCriteria.IncludeInstructor
    } else {
      return AvailabilityCriteria.IncludeLocationAndInstructor
    }
  }

  ngAfterViewInit() {
    this.formChangeSubscribe();
    this.nextButton.disbaledproperity = this.updateFormValidity();
    if (this.activityService.SelectedActivity$.value) {
      this.selectedClassActivity(this.SelectedActivityData);
    }
  }

  createActionButtons() {
    this.nextButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('next'),
      customclass: 'guest-details__confirm-btn',
    };
    this.cancelButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('previous'),
      customclass: 'reservation-details__previous-btn',
      disbaledproperity: true
    };
    this.CheckAvailabilityBtn = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('checkAvailability'),
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: true
    };
    this.previousButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('previous'),
      customclass: 'reservation-details__previous-btn',
    };
    this.nextButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('next'),
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: true
    };
  }
  selectedClassActivity(data) {
    console.log(data);
    this.SelectedActivityData = data;
    this.isSessionClass = this.SelectedActivityData.ClassType === ClassType.Session;
    const StaffList = data.StaffValues;
    this.minSizeAllowed = data.MinPartySize;
    this.coverTypes = data.CoverTypePrices.map(type => {
      return {
        Id: type.Id,
        Name: type.CoverTypeName
      }
    });
    this.bookingTypes = data.BookingTypeActivitiesMappings.map(type => {
      return {
        Id: type.Id,
        Name: type.BookingTypeName
      }
    });

    this.customizeSizeConfig[0].validation = [Validators.required, Validators.min(this.SelectedActivityData?.MinPartySize), Validators.max(this.SelectedActivityData?.MaxPartySize)];

    let instructorList  = this.InstructorList = this.getInstructor(StaffList);
    let locationList = this.LocationList = this.getLocations(data.LocationId);
    this.reservationConfig[0].options = this.InstructorList;
    this.reservationConfig[0].value = this.EditData && this.EditData.StaffIds ? this.EditData.StaffIds.length && (instructorList ?.length === 1 || (instructorList?.length > 1 && this.EditData.StaffIds.length !== instructorList?.length - 1)) ? this.EditData.StaffIds[0] : -1 :( instructorList?.length == 1 ? instructorList[0].id:-1);
    this.locationConfig[0].value = this.EditData && this.EditData.TableIds ? this.EditData.TableIds.length && (locationList ?.length === 1 || (locationList ?.length > 1 && this.EditData.TableIds.length !== locationList ?.length - 1)) ? this.EditData.TableIds[0] : -1 : ( locationList ?.length == 1 ? locationList[0].id : -1);
    this.locationConfig[0].options = this.LocationList;
    this.bookingType_config[0].options = this.calculatePartySize();
    this.coverTypeConfig = this.getCoverTypeConfig();
    this.coverTypeConfig = this.coverTypeConfig.map(config => {
      config.options = [{ id: 0, value: "none" }, ...this.bookingSizeArray];
      return config;
    })

    this.bookingTypeConfig = this.getBookingTypeConfig();
    this.bookingTypeConfig = this.bookingTypeConfig.map(config => {
      config.options = [{ id: 0, value: "none" }, ...this.bookingSizeArray];
      return config;
    })

    this.showSessionorSlots = false;
    this.selectedClassSchedule = [];
    this.SessionSlotsAvailableDates = [];
    this.components.forEach((x) => {
      if (this.SelectedActivityData.ClassType === 1) {
        if (x.form.controls["FromDate"]) {
          x.form.controls["FromDate"].setValue(data.StartDate);
          x.form.controls["FromDate"].disable();
          this.from_dateConfig[0].minDate = '';
          this.from_dateConfig[0].maxDate = '';
        }
        if (x.form.controls["ToDate"]) {
          x.form.controls["ToDate"].setValue(data.EndDate);
          x.form.controls["ToDate"].disable();
          this.to_dateConfig[0].minDate = '';
          this.to_dateConfig[0].maxDate = '';
        }
      } else {
        const currentDate = new Date();
        if (x.form.controls["FromDate"]) {
          x.form.controls["FromDate"].setValue(new Date(data.StartDate) > currentDate ? new Date(data.StartDate) : currentDate);
          x.form.controls["FromDate"].enable();
          this.from_dateConfig[0].minDate = new Date(data.StartDate) > currentDate ? new Date(data.StartDate) : currentDate;
          this.from_dateConfig[0].maxDate = data.EndDate;
        }
        if (x.form.controls["ToDate"]) {
          x.form.controls["ToDate"].setValue(data.EndDate);
          x.form.controls["ToDate"].enable();
          this.to_dateConfig[0].minDate = new Date(data.StartDate) > currentDate ? new Date(data.StartDate) : currentDate;
          this.to_dateConfig[0].maxDate = data.EndDate;
        }
      }
    });
    this.updateDateConfig();
    setTimeout(() => {
      this.coverTypeConfigChange();
      this.bookingTypeConfigChange();
    }, 500);
  }
  updateDateConfig() {
    this.from_dateConfig = [
      {
        type: 'date',
        name: 'FromDate',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('FromDate'),
        minDate: this.EditData?.StartDate ? this.EditData.StartDate : this.SelectedActivityData ? this.SelectedActivityData.StartDate : '',
        maxDate: this.EditData?.EndDate ? this.EditData.EndDate : this.SelectedActivityData ? this.SelectedActivityData.EndDate : '',
        class: "selector-date",
        validation: [Validators.required],
        value: this.EditData?.StartDate ? this.EditData.StartDate : this.SelectedActivityData ? this.SelectedActivityData.StartDate : '',
        disabled: this.SelectedActivityData?.ClassType == ClassType.Class
      }
    ];
    this.to_dateConfig = [
      {
        type: 'date',
        name: 'ToDate',
        placeholder: 'select',
        appearance: true,
        isFormArray: false,
        minDate: this.EditData?.StartDate ? this.EditData.StartDate : this.SelectedActivityData ? this.SelectedActivityData.StartDate : '',
        maxDate: this.EditData?.EndDate ? this.EditData.EndDate : this.SelectedActivityData ? this.SelectedActivityData.EndDate : '',
        label: this.ts.instant('ToDate'),
        class: "selector-date",
        validation: [Validators.required],
        value: this.EditData?.EndDate ? this.EditData.EndDate : this.SelectedActivityData ? this.SelectedActivityData.EndDate : '',
        disabled: this.SelectedActivityData?.ClassType == ClassType.Class
      },
    ]
  }
  coverTypeConfigChange() {
    if (this.coverTypeConfig.length) {
      this.Subscriptions.add(
        this.components.last.form.valueChanges.subscribe(value => {
          this.nextButton.disbaledproperity = !this.updateFormValidity();
          this.validCoverTypes = this.isCoverTypeMatchBookingSize()
        }));
    }
  }
  bookingTypeConfigChange() {
    if (this.bookingTypeConfig.length) {
      this.Subscriptions.add(
        this.components.filter((item, index) => index === 5)[0].form.valueChanges.subscribe(value => {
          this.nextButton.disbaledproperity = !this.updateFormValidity();
          this.validBookingTypes = this.isBookingTypeMatchBookingSize()
        }));
    }
  }

  getInstructor(staffList) {
    let SelectedStaffList = [];
    if (staffList.length > 1) {
      SelectedStaffList.push({ 'Id': -1, 'value': 'Any' });
    }
    staffList.forEach(staff => {
      const selectedStaff = this.activityService.InstructorList.filter(data => data.Id === staff.ServerId)[0];
      if (selectedStaff) {
        let serverval = "Unnamed";
        if (selectedStaff) {
          if (selectedStaff.Name) {
            serverval = selectedStaff.Name;
          }
          if (selectedStaff.LastName) {
            serverval = serverval + ' ' + selectedStaff.LastName;
          }
        }
        selectedStaff['value'] = serverval;

        SelectedStaffList.push(selectedStaff);
      }
    });
    SelectedStaffList = SelectedStaffList.map(data => {
      return {
        id: data.Id,
        value: data.value
      }
    })

    if (!(staffList.length > 1)) {
      this.reservationConfig = [
        {
          type: 'select',
          name: 'Instructor',
          placeholder: '',
          options: [],
          appearance: true,
          isFormArray: false,
          value: this.EditData ? this.EditData.StaffIds && this.EditData.StaffIds.length > 0 ? this.EditData.StaffIds[0] : SelectedStaffList[0].id : SelectedStaffList[0].id,
          label: this.ts.instant('SelectaInstructor'),
          class: "activity-instructor",
          validation: [Validators.required],
        }

      ];

    }
    return SelectedStaffList;
  }

  getLocations(LocationList) {
    let SelectedLocationList = [];
    if (LocationList.length > 1) {
      SelectedLocationList.push({ 'Id': -1, 'value': 'Any' });
    }
    LocationList.forEach(location => {
      const selectedLocation = this.activityService.LocationList.filter(data => data.Id === location.LocationId)[0];
      if (selectedLocation) {
        selectedLocation['value'] = selectedLocation.Name;
        SelectedLocationList.push(selectedLocation);
      }
    });
    SelectedLocationList = SelectedLocationList.map(data => {
      return {
        id: data.Id,
        value: data.value
      }
    })
    if (!(LocationList.length > 1)) {
      this.locationConfig = [
        {
          type: 'select',
          name: 'Location',
          placeholder: '',
          options: [],
          appearance: true,
          isFormArray: false,
          value: this.EditData ? this.EditData.Location && this.EditData.Location.length > 0 ? this.EditData.Location[0] : SelectedLocationList[0].id : SelectedLocationList[0].id,
          label: this.ts.instant('SelectaLocation'),
          class: "activity-instructor",
          validation: [Validators.required],
        }];
    }
    return SelectedLocationList;

  }


  setRatePlanCalculation(Slots, GuestTypes, BookingTypes, Location, BookingSize, ActivityId, SessionGroupId) {
    var request = {
      Slots: [],
      ActivityId,
      GuestTypes,
      BookingTypes,
      TableIds: Location,
      Size: +BookingSize,
      SessionSlot: {
        Sessions: SessionGroupId ? null : Slots,
        SessionGroupId: SessionGroupId
      },
      TrackMembershipNumber: this.activityService.selectedGuest && this.activityService.selectedGuest.TrackMembershipNumber,
      MemberType: this.activityService.selectedGuest?.MembershipType?.AllocationName,
      IsMemberActive: this.activityService.selectedGuest?.MemberActive,
      BookingBehavior: BookingBehavior.ClassOrSession
    } as ActivityRatePlanRequest;
    this.Subscriptions.add(this.activityService.GetSessionRatePlanCalculated(request).subscribe(response => {
      this.ratePlan = response.Payload;
      if (this.ratePlan && this.ratePlan.RatePlanCalculations) {
        this.ratePlan.RatePlanCalculations = this.ratePlan.SlotList = this.ratePlan.RatePlanCalculations.map(slot => {
          slot.coverTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.GuestTypeVariant ? slot.RatePlanVariants.GuestTypeVariant.map(coverVariant => {
            coverVariant.CoverTypeName = this.coverTypes.find(coverType => coverType.Id == coverVariant.CoverTypeId).Name;
            return coverVariant;
          }).filter(coverVariant => coverVariant.Variant) : [];
          slot.bookingTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.BookingTypeVariant ? slot.RatePlanVariants.BookingTypeVariant.map(bookingTypeVariant => {
            bookingTypeVariant.BookingTypeName = this.bookingTypes.find(bookingType => bookingType.Id == bookingTypeVariant.BookingTypeId).Name;
            return bookingTypeVariant;
          }).filter(bookingTypeVariant => bookingTypeVariant.Variant) : [];
          return slot;
        });
      } else {
        this.ratePlan.SlotList = Slots;
      }
      if (this.ratePlan.TotalRatePlan || this.ratePlan.RatePlanCalculations) {
        this.activityService.RatePlanList$.next(this.ratePlan);
      }
    }));
  }

  getCoverTypeConfig(): FieldConfig[] {
    return this.coverTypes.map(coverType => {
      return {
        type: 'select',
        label: coverType.Name,
        name: coverType.Name,
        value: (this.EditData && this.EditData.CoverTypeQuantities && this.EditData.CoverTypeQuantities.filter(ct => ct.CoverTypeId == coverType.Id && ct.Covers > 0).length > 0) ? this.bookingSizeArray[this.EditData.CoverTypeQuantities.filter(ct => ct.CoverTypeId == coverType.Id)[0].Covers - 1].id : 0,
        options: this.bookingSizeArray,
        class: 'activity-instructor',
        appearance: true,
        isFormArray: false,
      } as FieldConfig;
    })
  }

  getBookingTypeConfig(): FieldConfig[] {
    return this.bookingTypes.map(bookingType => {
      return {
        type: 'select',
        label: bookingType.Name,
        name: bookingType.Name,
        value: (this.EditData && this.EditData.BookingTypeQuantities && this.EditData.BookingTypeQuantities.filter(bt => bt.BookingTypeId == bookingType.Id && bt.BookingTypes > 0).length > 0) ? this.bookingSizeArray[this.EditData.BookingTypeQuantities.filter(bt => bt.BookingTypeId == bookingType.Id)[0].BookingTypes - 1].id : 0,
        options: this.bookingSizeArray,
        class: 'activity-instructor',
        appearance: true,
        isFormArray: false,
      } as FieldConfig;
    })
  }

  setCoverTypeValue(covertType) {
    this.EditData?.CoverTypes?.forEach(data => {
      if (data.CoverTypeId === covertType.Id) {
        return data.covers;
      }
    });
  }

  setBookingTypeValue(bookingType) {
    this.EditData?.BookingTypes?.forEach(data => {
      if (data.BookingTypeId === bookingType.Id) {
        return data.bookingTypes;
      }
    });
  }

  calculatePartySize() {
    this.bookingSizeArray = [];
    for (let i = 1; i <= this.SelectedActivityData?.MaxPartySize; i++) {
      this.bookingSizeArray.push({ id: i, value: i.toString() });
    }
    // this.bookingSizeArray.push({ id: this.maxSizeAllowed, value: this.maxSizeAllowed.toString() + "+" });

    return this.bookingSizeArray;
  }

  formChangeSubscribe() {
    this.components.forEach((x, index) => {
      this.Subscriptions.add(x.form?.valueChanges.pipe(debounceTime(100),
        distinctUntilChanged()).subscribe(value => {
          if (value.bookingType) {
            this.activityService.bookingType$.next(this.getFormComponent("bookingType")[0].form.controls.bookingType.value)
          }
          if (value.BookingSize) {
            this.activityService.additionalGuestLength = value.BookingSize;
          }
          if (value.Location || value.Instructor || value.FromDate || value.ToDate || value.BookingSize) {
            if (this.activityService.operation === operationType.create) {
              this.checkSessionorSlotAvailability();
            }
            if (this.activityService.operation === operationType.edit) {
              if (this.activityService.reservationToken || this.currentTab === ActivityTabs.BookingSelection) {
                this.formRepeatCount = this.formRepeatCount + 1;
                if (this.formRepeatCount > 4) {
                  this.checkSessionorSlotAvailability();
                }
              }
              else {
                if (this.currentTab === ActivityTabs.ActivitySelection) {
                  this.checkSessionorSlotAvailability();
                }
              }
            }
          }
          this.nextButton.disbaledproperity = !this.updateFormValidity();
          this.validCoverTypes = this.isCoverTypeMatchBookingSize();
          this.validBookingTypes = this.isBookingTypeMatchBookingSize();
        })
      )
    });
  }

  getSlotsForClass(requestedObject) {
    requestedObject.PropertyId = this.activityService.restaurantWidgetId;
    this.checkedItem = false;
    this.Subscriptions.add(this.activityService.GetClassSlots(requestedObject).subscribe(response => {
      let slots = response.Payload;
      this.SessionSlotsAvailableDates = slots.length ? slots.map((date, index) => {
        date.AvailableSessions = date.AvailableSessions
          .filter(session => session.Availability?.AvailabilityType != AvailabilityType.SelectionCriteriaNotMatched)
          .map((slot, datatindex) => {
            slot.Start = date.AvailableDate.split("T")[0] + "T" + slot.Start;
            slot.End = date.AvailableDate.split("T")[0] + "T" + slot.End;
            if (this.activityService.editPartyData$.value) {
              this.updateSlotBasedOnBookedSession(slot, date);
            }
            if (!this.isNotPastTimeSlot(slot.End) && !slot.checked) {
              slot.disabled = true;
            }
            return slot;
          }).sort((a, b) => {
            var c: any = new Date(a.Start);
            var d: any = new Date(b.Start);
            return c.getTime() - d.getTime();
          })
        return date;
      }) : null;
      if (this.SessionSlotsAvailableDates) {
        this.showSessionorSlots = true;
        this.SessionSlotsAvailableDates = this.SessionSlotsAvailableDates.filter(slot => slot.AvailableSessions.length);
        let isChecked = false;
        this.SessionSlotsAvailableDates.forEach((element, index) => {
          const checked = element.AvailableSessions.findIndex(x => x.checked);
          if (checked !== -1 && !this.checkedItem) {
            this.checkedItem = true;
            this.selectedIndex = index;
          }
        });
      }


      if (!this.isSessionClass) {
        this.availableSessions = [];
        this.classLessonList = [];
        this.SessionSlotsAvailableDates.forEach(elm => {
          this.availableSessions = [...this.availableSessions, ...elm.AvailableSessions]
        })
        var groupIdList: any[] = Utilities.uniqueBy(this.availableSessions, "SessionGroupId");
        groupIdList.forEach(group => {
          var selectedSession = this.availableSessions.find(session => session.SessionGroupId === +group.SessionGroupId);
          selectedSession.checked = this.activityService.editPartyData$.value && this.activityService.editPartyData$.value.SessionGroupId ? selectedSession.SessionGroupId === this.activityService.editPartyData$.value.SessionGroupId : false;
          this.classLessonList.push(selectedSession);
          const checkedItem = this.classLessonList.filter(x => x.checked);
          this.checkedItem = checkedItem.length ? true : false;
        })
        this.selectedClassSchedule = [];
        let groupList: any[] = Utilities.uniqueBy(this.availableSessions, "SessionGroupId", "DayOfWeek", "SessionId");
        groupList = groupList.filter(group => group.SessionGroupId == this.activityService.editPartyData$.value?.SessionGroupId);
        groupList.forEach(groupDetail => {
          if (!this.selectedClassSchedule[groupDetail.DayOfWeek]) {
            this.selectedClassSchedule[groupDetail.DayOfWeek] = [];
          }
          let selectedItem = this.availableSessions.find(session => session.SessionGroupId == groupDetail.SessionGroupId && session.DayOfWeek == groupDetail.DayOfWeek && session.SessionId == groupDetail.SessionId);
          this.selectedClassSchedule[groupDetail.DayOfWeek].push(selectedItem);
        });
      }
      this.nextButton.disbaledproperity = !this.updateFormValidity();
      // if (this.SelectedActivityData) {
      //   this.updateFormValidity();
      // }
      this.showSessionorSlots = true;

    }));
  }

  navClick(moveDirection) {
    if ((moveDirection === 1 && this.selectedIndex === this.SessionSlotsAvailableDates.length - 1)
      || (moveDirection === -1 && this.selectedIndex === 0)) {
      return;
    }
    this.selectedIndex = this.selectedIndex + moveDirection;
  }


  applyToOtherDates(selectedDateIndex, event) {

    var selectedSessionIndexes = this.SessionSlotsAvailableDates[selectedDateIndex].AvailableSessions.map((session, index) => session.checked ? index : -1).filter(sessionIndex => sessionIndex != -1);
    if(this.activityService.selectedGuest){
      var {MembershipType: memberTypename, MemberActive: memberActive} = this.activityService.selectedGuest;
      var memberType = this.activityService.restaurantWidgetSettings$.value.AllocationMappings.find(allocation => allocation.AllocationTypeName.trim().toLocaleLowerCase() === memberTypename.trim().toLocaleLowerCase());  
      if(memberType){
        var memberid = memberType.AllocationTypeId;
      }
    }
    if (event.checked) {
      this.sessionsUnavailable = [];
      if (!selectedSessionIndexes || !selectedSessionIndexes.length) {
        this.activityService.setMessageState(this.ts.instant("Select sessions to apply for all dates"), 0);
        return;
      }
      this.SessionSlotsAvailableDates.forEach(selectedDate => {
        selectedDate.AvailableSessions = selectedDate.AvailableSessions.map(session => {
          session.checked = false;
          return session;
        });
        selectedSessionIndexes.forEach(index => {
          if (selectedDate.AvailableSessions[index] && 
            (
              selectedDate.AvailableSessions[index].Availability?.AvailabilityType === AvailabilityType.OpenToAll
              || (selectedDate.AvailableSessions[index].Availability?.AvailabilityType === AvailabilityType.OpenToSpecificMember
                && ((selectedDate.AvailableSessions[index].Availability?.AllocationTypeId == memberid)
                || (this.IsMember(selectedDate.AvailableSessions[index].Availability) && memberid)) && memberActive)
            ) 
            && !selectedDate.AvailableSessions[index].disabled) {
            selectedDate.AvailableSessions[index].checked = true;
          } else {
            if (!this.sessionsUnavailable[index] || !this.sessionsUnavailable[index].dates) {
              this.sessionsUnavailable[index] = { session: this.ts.instant("Session") + " " + (index + 1) + " " + this.ts.instant("not available on") + " ", dates: "" }
            }
            this.sessionsUnavailable[index].dates += this.sessionsUnavailable[index].dates ? ", " + moment(selectedDate.AvailableDate).format("LL") : moment(selectedDate.AvailableDate).format("LL");
          }
        });
      });
      this.sessionsUnavailable = this.sessionsUnavailable.filter(item => item)
      if (!this.sessionsUnavailable || !this.sessionsUnavailable.length) {
        //this.toastrService.success(this.ts.instant("Applied"), "", { timeOut: 3000, closeButton: true });
      } else {
        let errorMessage = ''
        var errObj = {
          ErrorDetails: {
            Error: this.sessionsUnavailable.map(session => {
              errorMessage = errorMessage + session.session + session.dates + '. '
            })
          },
          ErrorType: true,
          dialogTitle: 'error'
        }
        this.activityService.setMessageState(errorMessage, 0);
      }
    } else {
      this.SessionSlotsAvailableDates.forEach(selectedDate => {
        selectedDate.AvailableSessions = selectedDate.AvailableSessions.map(session => {
          session.checked = false;
          return session;
        })
      });
      this.updateFormValidity();
    }
  }

  IsMember(slot : any) : boolean{
    if(!slot || !this.gs.restaurantWidgetSettings$.value.AllocationMappings) return false;
    let allocationType = this.gs.restaurantWidgetSettings$.value.AllocationMappings;
    let isAnyMember = allocationType.find(type => type.AllocationTypeId === slot.AllocationTypeId)?.AllocationTypeName == 'AnyMembers';
    return isAnyMember;
  }

  slotChangeListners(event) {
    if (this.SelectedActivityData && this.SelectedActivityData.ClassType == ClassType.Class && event.checked) {
      let groupIdList: any[] = Utilities.uniqueBy(this.availableSessions, "SessionGroupId", "DayOfWeek", "SessionId");
      this.selectedClassSchedule = [];
      groupIdList = groupIdList.filter(group => group.SessionGroupId == event.SessionGroupId);
      groupIdList.forEach(groupDetail => {
        if (!this.selectedClassSchedule[groupDetail.DayOfWeek]) {
          this.selectedClassSchedule[groupDetail.DayOfWeek] = [];
        }
        let selectedItem = this.availableSessions.find(session => session.SessionGroupId == groupDetail.SessionGroupId && session.DayOfWeek == groupDetail.DayOfWeek && session.SessionId == groupDetail.SessionId);
        this.selectedClassSchedule[groupDetail.DayOfWeek].push(selectedItem);
      });
      this.classLessonList.forEach(session => {
        if (session.SessionId != event.SessionId || session.SessionGroupId != event.SessionGroupId) {
          session.checked = false;
        }
      });
      const checkedItem = this.classLessonList.filter(x => x.checked);
      this.checkedItem = checkedItem.length ? true : false;
    } else if (!this.isMultiSlotSelection && event.checked) {
      let isChecked = false;
      this.SessionSlotsAvailableDates.forEach((element, index) => {
        element.AvailableSessions.forEach(session => {
          if (session.SessionId != event.SessionId) {
            session.checked = false;
          }
          if (session.checked) {
            isChecked = true;
          }
        });
      });
      this.checkedItem = isChecked;
    } else {
      if (this.classLessonList && this.classLessonList.length > 0) {
        const checkedItem = this.classLessonList.filter(x => x.checked);
        this.checkedItem = checkedItem.length ? true : false
      } else {
        let isChecked = false;
        this.SessionSlotsAvailableDates.forEach((element, index) => {
          element.AvailableSessions.forEach(session => {

            if (session.checked) {
              isChecked = true;
            }
          });
        });
        this.checkedItem = isChecked;
      }
    }
    this.nextButton.disbaledproperity = !this.updateFormValidity();
  }
  isSlotBooked(date, sessionId, editData): boolean {
    return editData.BookedSessions.findIndex(session => moment(session.BookedDate).diff(moment(date), 'days') == 0 && session.ActivitySessionId == sessionId && session.SessionState != PartyState.Cancelled) > -1;
  }


  getStateOfBookedSession(date, sessionId, editData): PartyState {
    return editData.BookedSessions.find(session => moment(session.BookedDate).diff(moment(date), 'days') == 0 && session.ActivitySessionId == sessionId).SessionState;
  }



  updateSlotBasedOnBookedSession(slot, date) {
    const editData = this.activityService.editPartyData$.value;
    slot.checked = editData && editData.BookedSessions && editData.BookedSessions.length > 0 ? this.isSlotBooked(date.AvailableDate, slot.SessionId, editData) : false;

    if (slot.checked && editData && editData.BookedSessions && editData.BookedSessions.length > 0 && this.getStateOfBookedSession(date.AvailableDate, slot.SessionId, editData) == PartyState.Seated) {
      slot.Availability.AvailabilityType = AvailabilityType.SelectionCriteriaNotMatched;
      slot.checked = false;
    }

  }

  gotoPreviousPage(event) {
    this.activityService.TabChange$.next(ActivityTabs.ActvityView);
    this.activityService.SaveBookingObj = {};
    this.resetPaymentInfo();
    if (this.activityService.lockResult && this.activityService.lockResult.SlotLockIdDTO) {
      this.activityService.unlockSessionsUrl(this.activityService.lockResult.SlotLockIdDTO.Id).subscribe(data => {
        this.activityService.lockResult = null;
        this.activityService.offTimer();
      });
    }
    // this.activityService.bookingSection$.  next(true);
  }

  resetPaymentInfo() {
    this.activityService.ispaymentInvolvedInfo = null;
    this.activityService.reservationAttemptInfo = null;
  }



  gotoNextPage(event) {
    if (this.activityService.selectedGuest && this.activityService.selectedGuest.TrackMembershipNumber && !this.activityService.selectedGuest?.MemberActive) {
      const popUpMessage = [{
        confirmationMessage: this.ts.instant('memberShipExpired'),
        dialogTitle: this.ts.instant('memberShipStatus'),
        showAlert: true
      }];
      const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', 'static', popUpMessage,
        popUpMessage[0].dialogTitle);
      const confirm = this.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '450px', '250px', false, 'No', 'ok',
        'ok', false)
      return;
    }
    this.setBookingData();
    this.lockTables();
    // this.activityService.TabChange$.next(1);
  }

  selectedItem(data, index) {
    this.SelectedActivityData = this.availableActivities[index];
    this.selectedClassActivity(this.SelectedActivityData);
  }

  lockTables() {

    let { ActivityId, FromDate, Slots, GuestTypes, BookingTypes, Location, StaffId, BookingSize, SessionGroupId } = this.activityService.SessionBookingObj;
    const classType = this.activityService.SessionBookingObj.ClassType;
    this.isSessionClass = classType === ClassType.Session;
    let lockRequest = {
      ActivityId: ActivityId,
      StartDate: FromDate,
      BookingSize: BookingSize,
      ClassType: classType,
      lockIdToIgnore: this.lockResponse?.SlotLockIdDTO?.Id || null,
      Sessions: classType == ClassType.Class ? [] : Slots,
      SessionGroupId: classType == ClassType.Class ? SessionGroupId : null,
      ReservationIdToIgnore: this.activityService.editPartyData$.value?.Id || null
    } as LockSessionRequestDTO;
    this.Subscriptions.add(
      this.activityService
        .lockSessions(this.activityService.restaurantWidgetId, lockRequest).subscribe(response => {
          this.lockResponse = response.Payload;
          this.activityService.lockResult = this.lockResponse;
          this.createSaveRequestObject();
          if (!this.activityService.restaurantWidgetSettings$.value.IsCartEnabled || this.activityService.operation !== operationType.create) {
            let timer = moment(response.Payload.ExpiresAt).diff(moment(response.Payload.LockedAt), "seconds");
            this.activityService.showTimer = true;
            this.activityService.runTimer(timer);
          }
          this.activityService.TabChange$.next(ActivityTabs.ReservationDetails);
          if (this.activityService.operation == operationType.edit) {
            this.activityService.additionalGuestPage = false;
          }
          if (this.activityService.operation !== operationType.create) {
            this.setRatePlanCalculation(Slots, GuestTypes, BookingTypes, Location, BookingSize, ActivityId, classType == ClassType.Class ? SessionGroupId : null);
          }
        }));
  }



  setRatePlanData(data) {
    this.ratePlan = data;
    if (this.ratePlan && this.ratePlan.RatePlanCalculations) {
      this.ratePlan.RatePlanCalculations = this.ratePlan.RatePlanCalculations.map(slot => {
        slot.coverTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.GuestTypeVariant ? slot.RatePlanVariants.GuestTypeVariant.map(coverVariant => {
          coverVariant.CoverTypeName = this.coverTypes.find(coverType => coverType.Id == coverVariant.CoverTypeId).Name;
          return coverVariant;
        }).filter(coverVariant => coverVariant.Variant) : [];
        slot.bookingTypevariants = slot.RatePlanVariants && slot.RatePlanVariants.BookingTypeVariant ? slot.RatePlanVariants.BookingTypeVariant.map(bookingTypeVariant => {
          bookingTypeVariant.BookingTypeName = this.bookingTypes.find(bookingType => bookingType.Id == bookingTypeVariant.BookingTypeId).Name;
          return bookingTypeVariant;
        }).filter(bookingTypeVariant => bookingTypeVariant.Variant) : [];
        return slot;
      });
    }
    if (this.ratePlan.TotalRatePlan || this.ratePlan.RatePlanCalculations) {
      this.activityService.RatePlanList$.next(this.ratePlan);
    }
    this.activityService.SelectedClassSchedule$.next(this.selectedClassSchedule);
    this.createSaveRequestObject();
  }

  createSaveRequestObject() {
    var bookingData = this.activityService.SessionBookingObj;
    if (this.activityService.operation === operationType.create) {
      this.activityService.SaveBookingObj = {
        "Id": bookingData.ActivityId,
        "Size": bookingData.BookingSize,
        "RemindAboutVisit": false,
        "RemindAboutVisitEmail": false,
        "AgreedWithTermsOfUse": true,
        "Contact": {},
        "Slots": this.getSlotsObj(),
        "Slot": this.getRequestObjectSlot(),
        "Sessions": this.getRequestObjectSlots(),
        "PartyId": null,
        "SeatingAreaId": null,
        "SeatingTypeId": null,
        "Notes": [],
        "TableIds": bookingData.Location,
        "InstructorIds": bookingData.StaffId,
        "CoverTypes": bookingData.GuestTypes,
        "BookingTypes": bookingData.BookingTypes,
        "IsCommunalTable": false,
        "FromWebsite": true,
        "Language": 0,
        "ReservationAttemptId": null,
        "waiverFormTransactionId": null,
        "SecondaryContactsList": null,
        "BookingBehavior": BookingBehavior.ClassOrSession,
        "SpecialMealId": bookingData.ActivityId,
        "StaffId": bookingData.StaffId,
        "StaffIds": bookingData.StaffId,
        "StartDate": new Date(bookingData.FromDate).toDateString(),//(moment(bookingData.FromDate).format()).split("+")[0],
        "EndDate": new Date(bookingData.ToDate).toDateString(),//(moment(bookingData.ToDate).format()).split("+")[0],
        "SelectedSchedule": this.selectedClassSchedule,
        "SelectedTimeSlots": this.SelectedTimeSlots,
        "SessionGroupId": bookingData.SessionGroupId,
        "SelectedActivity": this.SelectedActivityData
      }
    } else {
      this.activityService.SaveBookingObj.Id = bookingData.ActivityId;
      this.activityService.SaveBookingObj.Size = bookingData.BookingSize;
      this.activityService.SaveBookingObj.Slot = this.getRequestObjectSlot();
      this.activityService.SaveBookingObj.Sessions = this.getRequestObjectSlots();
      this.activityService.SaveBookingObj.StartDate =new Date(bookingData.FromDate).toDateString();// (moment(bookingData.FromDate).format()).split("+")[0];
      this.activityService.SaveBookingObj.EndDate = new Date(bookingData.ToDate).toDateString();//(moment(bookingData.ToDate).format()).split("+")[0];
      this.activityService.SaveBookingObj.SpecialMealId = bookingData.ActivityId;
      this.activityService.SaveBookingObj.StaffId = bookingData.StaffId;
      this.activityService.SaveBookingObj.StaffIds = bookingData.StaffId;
      this.activityService.SaveBookingObj.TableIds = bookingData.Location;
      this.activityService.SaveBookingObj.InstructorIds = bookingData.StaffId;
      this.activityService.SaveBookingObj.CoverTypes = bookingData.GuestTypes;
      this.activityService.SaveBookingObj.BookingTypes = bookingData.BookingTypes;
      this.activityService.SaveBookingObj.selectedClassSchedule = this.selectedClassSchedule;
      this.activityService.SaveBookingObj.SelectedTimeSlots = this.SelectedTimeSlots;
      this.activityService.SaveBookingObj.SelectedActivity = this.SelectedActivityData;
      this.activityService.SaveBookingObj.BookingBehavior = BookingBehavior.ClassOrSession;
      this.activityService.SaveBookingObj.FromWebsite = true;
    }
  }

  getRequestObjectSlots() {
    var bookingData = this.activityService.SessionBookingObj;
    var sessionClass = this.activityService.SessionBookingObj.ClassType === ClassType.Session;

    return {
      LockId: this.lockResponse?.SlotLockIdDTO?.Id,
      Sessions: sessionClass ? bookingData.Slots : [],
      SessionGroupId: sessionClass ? null : bookingData.SessionGroupId
    }
  }

  getRequestObjectSlot() {
    var bookingData: SessionBookingDTO = this.activityService.SessionBookingObj;

    return {
      "Time": new Date(bookingData.FromDate).toDateString(),//(moment(bookingData.FromDate).format()).split("+")[0],
      "LockId": this.lockResponse?.SlotLockIdDTO?.Id,
      "Type": bookingData.AvailabilityCriteria
    }
  }

  isNotPastTimeSlot(slotDateTime): boolean {
    const maxPastTime = this.activityService.restaurantWidgetSettings$.value.MaxPastTimeForReservationsInMinutes;
    const currentTime = Utilities.getRestaurantDateTime(this.activityService.restaurantWidgetSettings$.value.DaylightDelta);
    const past1hr = new Date(currentTime.valueOf());
    const slotTime = Utilities.parseDateString(slotDateTime);
    return slotTime >= past1hr;
  }
  ngOnDestroy(): void {
    if (this.Subscriptions) { this.Subscriptions.unsubscribe(); }
  }

  UniqueArrayOfObject(array, FirstkeyToBeUnique, SecondKeyToBeUnique) {
    return array.filter((data, index) => !array.slice(index + 1)
      .some(y => y[FirstkeyToBeUnique] === data[FirstkeyToBeUnique] && y[SecondKeyToBeUnique] === data[SecondKeyToBeUnique]));
  }

}
